<template>
  <div id="app">
    <Home ref="home" @showSelectedYear="showSelectedYear" />
    <Footer />
    <Picker ref="picker" @refreshHomeYear="refreshHomeYear" />
  </div>
</template>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /*border: 2px dashed #333;*/
  height: 100%;
}

@media screen and (min-width: 769px) {
  html #app {
    width: 480px;
    margin: 0 auto;
    overflow: hidden;
  }
}
</style>

<script>
import Home from './views/Home.vue';
import Footer from './views/Footer.vue';
import Picker from './views/Picker.vue';

export default {
  name: 'app',
  components: {
    Home: Home,
    Footer: Footer,
    Picker: Picker,
  },
  methods: {
    showSelectedYear(year) {
      this.$refs.picker.showSelectedYear(year);
    },
    refreshHomeYear(year) {
      this.$refs.home.refreshHomeYear(year);
    }
  }
}

</script>
